const host = () => {
  let base = `${window.location.protocol}//${window.location.hostname}`
  if (window.location.port) {
    base += `:${window.location.port}`
  }
  return base
}

export const BASE_HOST_URL = host()
